import {inject} from '@angular/core';
import {CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree} from '@angular/router';
import {AutoLoginAllRoutesGuard} from 'angular-auth-oidc-client';
import {NGXLogger} from 'ngx-logger';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';

import {PortalMessageBroker} from '../portal/portal-message-broker';


/**
 * Guard der prüft ob der Nutzer angemeldet ist.<br>
 * Hierbei wird sowohl der Standalone-Login als auch der Login über das Portal unterstützt.
 */
export const authGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {
  
  const logger = inject(NGXLogger);
  const portalMessageBroker = inject(PortalMessageBroker);
  const autoLoginGuard = inject(AutoLoginAllRoutesGuard);

  /**
   * Prüft bzw. stellt sicher das der Nutzer entweder über das Portal<br>
   * oder im Standalone-Modus angemeldet ist.
   *
   * @param route
   * @param state
   * @private
   */
  const checkAuth = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {

    // INFO: check for running in portal
    if (portalMessageBroker.isRunningInPortal()) {
      logger.trace('AuthGuard.checkAuth(): running in portal: ', true);
      // INFO: assume logged in
      return true;
    }

    // INFO: delegate to AutoLoginGuard
    return autoLoginGuard.canActivate(route, state)
      .pipe(
        tap(canActivate => {
          logger.trace('AuthGuard.checkAuth(): running in standalone: ', canActivate);
        }),
      );
  };

  return checkAuth(route, state);
};
